import { WifiOff, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

export const OfflineBanner = ({ isOffline }) => {
  if (!isOffline) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-2"
      data-testid="offline-banner"
    >
      <WifiOff className="w-4 h-4" />
      <span>You are offline. Some features may be limited.</span>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => window.location.reload()}
        className="text-white hover:bg-amber-600 h-6 px-2 ml-2"
      >
        <RefreshCw className="w-3 h-3 mr-1" />
        Retry
      </Button>
    </div>
  );
};
